// Feature: notification rules, channels, deliveries, in-app inbox (PLAN §12.1).
import { createRoute } from "@tanstack/react-router";
import "./notifications.css";
import { registerFeature } from "../registry";
import { RulesPage } from "./RulesPage";
import { ChannelsPage } from "./ChannelsPage";
import { DeliveriesPage } from "./DeliveriesPage";
import { InboxItemPage, InboxPage } from "./InboxPage";

registerFeature({
  routes: (appRoute) => [
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/notifications", component: RulesPage }),
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/notifications/channels", component: ChannelsPage, validateSearch: (s: Record<string, unknown>) => s as { slack?: string; team?: string; focus?: string } }),
    createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/notifications/deliveries", component: DeliveriesPage, validateSearch: (s: Record<string, unknown>) => s as { channelId?: string; status?: string } }),
    createRoute({ getParentRoute: () => appRoute, path: "/inbox", component: InboxPage }),
    createRoute({ getParentRoute: () => appRoute, path: "/inbox/$itemId", component: InboxItemPage }),
  ],
  nav: [
    { label: "Notifications", to: "/orgs/$org/notifications", section: "main", order: 50, needsOrg: true },
  ],
});

export { InboxBell } from "./InboxBell";
